<div class="content">
  <section class="main">
    <picture>
      <img [src]="'/assets/img/error/error-page-grumpy.svg' | formatAbsolute" alt="Lekkerland Grumpy"/>
    </picture>
    <div class="text">
      <h1>Oh, etwas ist schief gelaufen!</h1>
      <p class="lead"><a href="https://shop.lekkerland.de/"><strong>Hier</strong></a> kommen Sie zurück zum Lekkerland24 Shop.</p>
    </div>
  </section>
</div>
